import constants from "../constants";

const {
  FETCH_PARTNER_ACTIVITIES_DONE,
  FETCH_BOOKMARK_LISTS_DONE,
} = constants;

const defaultState = {
  initial: null,
  cache: {},
  next: "",
};

function pois(state = { ...defaultState }, action) {
  switch (action.type) {
    case constants.POI_UNMOUNT: {
      return {
        initial: null,
        cache: { ...state.cache },
        next: "",
      };
    }
    case "FETCH_POI": {
      return {
        initial: null,
        next: "",
        cache: {
          ...state.cache,
        },
      };
    }
    case "FETCH_POI_DONE": {
      return {
        initial: action.data,
        cache: {
          ...state.cache,
        },
        next: state.next,
      };
    }
    case FETCH_BOOKMARK_LISTS_DONE: {
      return {
        initial: { ...state.initial },
        cache: {
          ...action.data.resources,
        },
        next: state.next,
      };
    }
    case FETCH_PARTNER_ACTIVITIES_DONE: {
      return {
        initial: {
          ...state.initial,
          partnerActivities: action.data.partnerActivities,
        },
        cache: { ...state.cache },
        next: state.next,
      };
    }
    default: {
      return state;
    }
  }
}


export default pois;



// WEBPACK FOOTER //
// ./assets/pois/reducers/pois.js